import { render, staticRenderFns } from "./SwitcherIcon.vue?vue&type=template&id=7563f0c6&"
import script from "./SwitcherIcon.vue?vue&type=script&lang=ts&"
export * from "./SwitcherIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports